/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserType } from '../../models/user-type';

export interface ApiV0UserGetUserTypeGet$Plain$Params {
}

export function apiV0UserGetUserTypeGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0UserGetUserTypeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UserType>> {
  const rb = new RequestBuilder(rootUrl, apiV0UserGetUserTypeGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserType>;
    })
  );
}

apiV0UserGetUserTypeGet$Plain.PATH = '/api/v0/user/getUserType';
